var React = require( 'react' );
var createReactClass = require('create-react-class');

var MatrixRowItem = createReactClass({

    handleChange: function(event) {
      var userResponse = {
          tag: this.props.name,
          text: this.props.label,
          value: event.target.value,
          rowValue: this.props.rowValue,
          unique: this.props.unique,
          option: {
              matrix: true,
              selected: event.target.checked,
              allowMulti: this.props.allowMulti,              
          }
      };
      this.props.handleResponse(userResponse);
    },

    render: function () {
      const inputType = (this.props.allowMulti) ? 'checkbox' : 'radio';

        return (
            <div className="option">
                <div className={inputType}>
                    <input 
                        type={inputType}
                        id={this.props.name}
                        name={this.props.name}
                        checked={this.props.checked}
                        onClick={this.handleChange}
                        value={this.props.value} />
                    <label htmlFor={this.props.name}>
                        <i className="ion-checkmark" />
                    </label>
                </div>
            </div>
        );
    }
});

module.exports = MatrixRowItem;



// WEBPACK FOOTER //
// ./src/common/routes/survey/components/field-types/matrix/matrixRowItem.jsx